export enum ETripNature {
    Road = 'road',
    Air = 'air',
    Sea = 'sea',
}

export function getTripNatureLabel(nature: ETripNature): string {
    switch (nature) {
        case ETripNature.Road:
            return 'Road Trip';
        case ETripNature.Air:
            return 'Flight Trip';
        case ETripNature.Sea:
            return 'Sea Trip';
        default:
            throw new Error(`Unknown trip nature: ${nature}`);
    }
}

export function convertStringToTripNature(value: string): ETripNature {
    switch (`${value}`.toLowerCase()) {
        case 'air':
            return ETripNature.Air;
        case 'sea':
            return ETripNature.Sea;
        case 'road':
        default:
            return ETripNature.Road;
    }
}
